import { extendTheme } from '@chakra-ui/react';

import {
  AlertStyle,
  BadgeStyle,
  ButtonStyle,
  FormStyle,
  InputStyle,
  ModalStyle,
  SelectStyle,
  TagStyle,
} from './components';

const colors = {
  brand: {
    50: '#EAEEF5',
    100: '#D3DDEF',
    200: '#BACBEB',
    300: '#80A2EB',
    400: '#3B71F6',
    500: '#1554FF',
    600: '#003FC7',
    700: '#002E8F',
    800: '#001D57',
    900: '#000B1F',
  },
  secondary: {
    1: '#0272B1',
    2: '#EFF6FF',
  },
  neutral: {
    2: '#52525D',
    50: '#F8F8FA',
    100: '#EFEFF1',
    200: '#E0E1E3',
    300: '#CFD2D6',
    400: '#9DA5B1',
    500: '#8B95A6',
    600: '#79859A',
    700: '#4B5566',
    800: '#282E39',
    900: '#040609',
  },
  business: {
    900: '#002373',
  },
  inovation: {
    50: '#E4F9F6',
    100: '#CFF5F0',
    200: '#BAF1EB',
    300: '#A5EEE7',
    400: '#8FEBE4',
    500: '#78E9E2',
    600: '#61E8E1',
    700: '#49E7E0',
    800: '#00E6E6',
    900: '#06C3BD',
  },
  'sustainability-green': {
    50: '#EEFDEE',
    100: '#DFFBDF',
    200: '#D0FAD2',
    300: '#C0FAC6',
    400: '#B0F9BB',
    500: '#8FFAA8',
    600: '#7EFCA0',
    700: '#6CFD9A',
    800: '#5AFF96',
    900: '#4BB86B',
  },
  'sustainability-pink': {
    900: '#FF00E6',
  },
  'driver-centricity': {
    50: '#FCEAEF',
    100: '#FBD9E0',
    200: '#F9C7D2',
    300: '#F9B5C2',
    400: '#F8A2B1',
    500: '#F98FA0',
    600: '#FA7B8D',
    700: '#FB667A',
    800: '#FF3C50',
    900: '#B7364C',
  },
  alert: {
    50: '#FFF4C4',
    100: '#FFEDAB',
    500: '#FFCC50',
    800: '#FCAB10',
    900: '#C29106',
  },
  blue: {
    200: '#BFDBFE',
    500: '#3B82F6',
  },
};
const fonts = {
  body: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  heading:
    "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  mono: "SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace",
};

const components = {
  Alert: AlertStyle,
  Badge: BadgeStyle,
  Button: ButtonStyle,
  Input: InputStyle,
  Tag: TagStyle,
  Form: FormStyle,
  Modal: ModalStyle,
  Select: SelectStyle,
};

export const theme = extendTheme({ fonts, colors, components });
